import { render, staticRenderFns } from "./kzgl.vue?vue&type=template&id=8ddda422&scoped=true"
import script from "./kzgl.vue?vue&type=script&lang=js"
export * from "./kzgl.vue?vue&type=script&lang=js"
import style0 from "./kzgl.vue?vue&type=style&index=0&id=8ddda422&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ddda422",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ddda422')) {
      api.createRecord('8ddda422', component.options)
    } else {
      api.reload('8ddda422', component.options)
    }
    module.hot.accept("./kzgl.vue?vue&type=template&id=8ddda422&scoped=true", function () {
      api.rerender('8ddda422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hsycjkequipmentmanagement/components/kzgl.vue"
export default component.exports